import {browserHistory} from 'react-router';
import axios from 'axios';

const XmlService = {

  getXml( id, locale ) {
    const language = locale ? locale.locale : 'en';
    return `<?xml version="1.0" encoding="ISO-8859-1"?>
      <content method="getReport" sessionId="incms1-1dedfc89:161438eab46:3f3" authorityId="incms1.1.SYS0001.local-11" user="7" userName="USUARIO CONSULTA " language="${language}" country="KE" profileId="1">
      <Query><method>KP_CF_CC_ACCOUNT_DETAIL</method><ArgumentList>
      <argument value="${id}" /></ArgumentList>
      <ArgumentList><argument value="${id}" /> </ArgumentList>
      <ArgumentList><argument value="${id}" /></ArgumentList>
      <ArgumentList><argument value="${id}" /> </ArgumentList>
      <ArgumentList><argument value="${id}" /> </ArgumentList>
      <ArgumentList><argument value="${id}" /></ArgumentList>
      <ArgumentList><argument value="${id}" /> </ArgumentList>
      <ArgumentList><argument value="${id}" /></ArgumentList>
      <ArgumentList><argument value="${id}" /> </ArgumentList>
      <ArgumentList><argument value="${id}" /></ArgumentList>
      <ArgumentList><argument value="${id}" /> </ArgumentList>
      <ArgumentList><argument value="${id}" /></ArgumentList>
      <ArgumentList><argument value="${id}" /></ArgumentList>
      <ArgumentList><argument value="${id}"/></ArgumentList>
      </Query>
      <ReportTemplate>CF_CC_ACCOUNT_DETAIL</ReportTemplate>
      </content>`
  },
};

export default XmlService;



// WEBPACK FOOTER //
// ./services/XmlService.js